// Timer state uses the stable occurrence ID; API adapters resolve its database ID.
export function timerTaskId(task: any): string | null {
    const value = typeof task === 'object' && task !== null ? task.id ?? task.originalId : task;
    const id = String(value ?? '');
    if (/^[1-9]\d*$/.test(id)) return id;
    // Two occurrences of the same series must never share timer state.
    return /^[1-9]\d*&\d{2}\.\d{2}\.\d{4}$/.test(id) ? id : null;
}

export function elapsedSeconds(runTime: number, startTime: number | null, now = Date.now()) {
    return runTime + (startTime ? Math.max(0, Math.floor((now - startTime) / 1000)) : 0);
}

export function todayForTimer(settings: any, now = new Date()): string {
    if (settings?.timeZoneId) {
        try {
            const parts = new Intl.DateTimeFormat('en-GB', {
                timeZone: settings.timeZoneId, day: '2-digit', month: '2-digit', year: 'numeric',
            }).formatToParts(now);
            const part = (type: string) => parts.find(p => p.type === type)?.value;
            return `${part('day')}.${part('month')}.${part('year')}`;
        } catch { /* Legacy settings may only contain the numeric UTC offset. */ }
    }
    const offset = settings?.timeZone;
    const utc = offset != null && Number.isFinite(Number(offset));
    const date = utc ? new Date(now.getTime() + Number(offset) * 3600000) : now;
    return [utc ? date.getUTCDate() : date.getDate(), (utc ? date.getUTCMonth() : date.getMonth()) + 1,
        utc ? date.getUTCFullYear() : date.getFullYear()].map((n, i) => i < 2 ? String(n).padStart(2, '0') : n).join('.');
}

export function canStartTaskTimer(task: any, settings: any, now = new Date()) {
    return !!timerTaskId(task) && !task.isCompleted && !task.isDelete && !task.isTemplate && !task.isRecurrenceSeries &&
        task.date === todayForTimer(settings, now);
}
